export type { ProductSentimentFormValues } from '@/entities/dashboard-template';

// --- TemplateFormValues (하위 호환 alias) ---

/** @deprecated ProductSentimentFormValues 사용 */
export type { ProductSentimentFormValues as TemplateFormValues } from '@/entities/dashboard-template';

// --- Scraping Job Selection ---

export type ScrapingJobSelection = {
  alias: string;
  title: string;
  productName: string | undefined;
  startDate: string | undefined;
  endDate: string | undefined;
};

// --- Creation Step (대시보드 생성 진행 상태) ---

const CREATION_STEP = {
  DASHBOARD: 'DASHBOARD',
  CHARTS: 'CHARTS',
  LAYOUT: 'LAYOUT',
} as const;

type CreationStepType = (typeof CREATION_STEP)[keyof typeof CREATION_STEP];

const CREATION_STEP_STATUS = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;

type CreationStepStatusType =
  (typeof CREATION_STEP_STATUS)[keyof typeof CREATION_STEP_STATUS];

export type CreationStepState = {
  step: CreationStepType;
  status: CreationStepStatusType;
  label: string;
};

export { CREATION_STEP, CREATION_STEP_STATUS };
